   // src/reducers.js
   import { combineReducers } from 'redux';
   import userReducer from './userReducer'; // Adjust the path to your user reducer

   const rootReducer = combineReducers({
     user: userReducer,
     // Add other reducers here if needed
   });

   export default rootReducer;
   